export const SETSOURCELIST = "SETSOURCELIST";
export const SETSTAGELIST = "SETSTAGELIST";
export const SETVERTICALLIST = "SETVERTICALLIST";
export const SETSTATUSLIST = "SETSTATUSLIST";
export const SETTASKSTATUSLIST = "SETTASKSTATUSLIST";
export const SETUSERROLESLIST = "SETUSERROLESLIST";
export const SETROLEAUTHORIZATIONLIST = "SETROLEAUTHORIZATIONLIST";
export const SETAUTHORIZEDPAGES = "SETAUTHORIZEDPAGES";
export const SETUSERLIST = "SETUSERLIST";
export const SETADVANCESERIESLIST = "SETADVANCESERIESLIST";
export const SETADVANCESETTING = "SETADVANCESETTING";
export const SETACCOUNTLIST = "SETACCOUNTLIST";
export const SETPROJECTTYPELIST = "SETPROJECTTYPELIST";
export const SETPROJECTSTATUSLIST = "SETPROJECTSTATUSLIST";
export const SETDEPARTMENTLIST = "SETDEPARTMENTLIST";
export const SETDEPARTMENTDETAIL = "SETDEPARTMENTDETAIL";
export const SETTICKETLEVELLIST = "SETTICKETLEVELLIST";
export const SETTICKETPRIORITYLIST = "SETTICKETPRIORITYLIST";
export const SETTICKETSTATUSLIST = "SETTICKETSTATUSLIST";
export const CLEARDOC = "CLEARDOC";
export const SETNOTIFICATIONLIST = "SETNOTIFICATIONLIST";
export const SETHISTORYLIST = "SETHISTORYLIST";
export const SETLEADSSOURCELIST = "SETLEADSSOURCELIST";
export const SETLEADSQUALIFICATIONLIST = "SETLEADSQUALIFICATIONLIST";
export const SETLEADSLIST = "SETLEADSLIST";
export const SETDEPARTMENTDDLIST = "SETDEPARTMENTDDLIST";
export const SETLOCATIONLIST = "SETLOCATIONLIST";
export const SETLOCATIONDEFAULTLIST = "SETLOCATIONDEFAULTLIST";
export const SETLEADSINDUSTRYLIST = "SETLEADSINDUSTRYLIST";
export const SETLEADSBRANDLIST = "SETLEADSBRANDLIST";
export const SETMANAGERLIST = "SETMANAGERLIST";
export const SETPOLICYLIST = "SETPOLICYLIST";
export const SETROLELIST = "SETROLELIST";
export const SETDISPLAYNAMES = "SETDISPLAYNAMES";
export const SETENQUIRYCATEGORY = "SETENQUIRYCATEGORY";
export const SETENQUIRYSUBCATEGORY = "SETENQUIRYSUBCATEGORY";
export const SETENQUIRYTYPE = "SETENQUIRYTYPE";
export const SETENQUIRYPRIORITYLIST = "SETENQUIRYPRIORITYLIST";
export const SETENQUIRYPAYMENTSLIST = "SETENQUIRYPAYMENTSLIST";
export const SETENQUIRYPACKINGSTYLELIST = "SETENQUIRYPACKINGSTYLELIST";
export const SETENQUIRYDISPATCHTYPELIST = "SETENQUIRYDISPATCHTYPELIST";
export const SETENQUIRYFACSTATUSLIST = "SETENQUIRYFACSTATUSLIST";
export const SETPRODUCTCATLIST = "SETPRODUCTCATLIST";
export const SETCOMPLAINTCATLIST = "SETCOMPLAINTCATLIST";
export const SETCOMPLAINTSOLUTION = "SETCOMPLAINTSOLUTION";
export const SETCOMPLAINTTYPELIST = "SETCOMPLAINTTYPELIST";
export const SETCOMPLAINTSTATUSLIST = "SETCOMPLAINTSTATUSLIST";
export const SETMODEOFTRANSLIST = "SETMODEOFTRANSLIST";
export const SETUSERBYID = "SETUSERBYID";
export const SETENQUIRYPROSUBCATEGORY = "SETENQUIRYPROSUBCATEGORY";
export const SETENQUIRYPROSUBCATEGORYONE = "SETENQUIRYPROSUBCATEGORYONE";
export const SETTERMSANDCONDITIONS = "SETTERMSANDCONDITIONS";
export const SETSETTINGSFLEXISTATUS = "SETSETTINGSFLEXISTATUS";
export const SETSETTINGSENQUIRYSTATUS = "SETSETTINGSENQUIRYSTATUS";
export const SETSETTINGSLEADSTATUS = "SETSETTINGSLEADSTATUS";
export const SETPROCATEGORY = "SETPROCATEGORY";
export const SETPROCATEGORY1 = "SETPROCATEGORY1";
export const SETPROCATEGORY2 = "SETPROCATEGORY2";
export const SETLOCATIONCODE = "SETLOCATIONCODE";
export const SETNOTIFYCONFIGLIST = "SETNOTIFYCONFIGLIST";